<template>
  <div class="overviewFile">
    <!-- <div class="header">
      <el-button @click="previewClick()">预览</el-button>
    </div>
    <el-divider></el-divider>-->
    <div class="main">
      <!--文档word.excel  这个文件必须是可以公共访问的，有的项目用的是内网，则无法使用该方法-->
      <div v-if="showDoc == true" class="content">
        <iframe frameborder="0" :src="fileUrl" width="100%"></iframe>
      </div>
      <!--pdf-->
      <div v-else-if="showPdf == true" class="content">
        <embed :src="fileUrl" style="width: 100%; height: 100%" />
      </div>
      <!--图片-->
      <div v-else-if="showImg == true" class="content">
        <el-image :src="fileUrl" style="width: 100%"></el-image>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showDoc: false,
      showPdf: false,
      showVideo: false,
      showImg: false,
      fileUrl: "",
      fileName: "",
    };
  },
  created() {
    this.fileUrl = this.$route.query.filePath;
    this.fileName = this.$route.query.fileName;
    //    console.log(overviewFile);
    //   this.fileUrl=overviewFile.filePath;
    this.previewClick();
  },
  mounted() {},
  methods: {
    /*
     * 判断文档类型 根据不同的文档类型 使用不同的显示方法
     *
     * */
    previewClick() {
      this.showDoc = false;
      this.showPdf = false;
      this.showVideo = false;
      this.showImg = false;

      //   let fileUrl = "";
      // fileUrl = 'https://fzaiot.juhaolian.cn/hisense-systemServer/template/vehicleManage.xlsx'        //xlsx
      //   fileUrl = "http://down.gerenjianli.com/mb2018/jianli_moban_018417.docx"; //word文档
      // fileUrl = 'http://47.105.218.26:8888/group1/M00/00/00/rB-LJlzT042AbKdCAAiu_35Yccs182.pdf'       //pdf
      // fileUrl = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1604049980112&di=98d182a26b2acd8627bb2a0f781a1183&imgtype=0&src=http%3A%2F%2Fa3.att.hudong.com%2F64%2F52%2F01300000407527124482522224765.jpg'    //图片
      //  this.fileUrl='http://atom-contracts.oss-cn-shanghai.aliyuncs.com/contract/items/20201020/49174300919300233648281476.docx?Expires=1604283733&OSSAccessKeyId=LTAI4G23e2BQjPtntoCj9jpS&Signature=ycF8dRPOl6xW8JH9aQ2KufZFJTo%3D'
      //  let type = this.fileUrl.substring(this.fileUrl.lastIndexOf(".") + 1); //文件类型
      // let typeLast =
      //   this.fileUrl.indexOf("?") > 0
      //     ? this.fileUrl.indexOf("?")
      //     : this.fileUrl.length;
      // let type = this.fileUrl.substring(
      //   this.fileUrl.lastIndexOf(".") + 1,typeLast); //文件类型
      if (
        this.fileName.indexOf("xls") != -1 ||
        this.fileName.indexOf("xslx") != -1 ||
        this.fileName.indexOf("xlsx") != -1
      ) {
        this.showDoc = true;
      } else if (
        this.fileName.indexOf("doc") != -1 ||
        this.fileName.indexOf("docx") != -1 ||
        this.fileName.indexOf("pdf") != -1
      ) {
        this.showPdf = true;
      } else if (
        this.fileName.indexOf("jpg") != -1 ||
        this.fileName.indexOf("png") != -1 ||
        this.fileName.indexOf("jpeg") != -1
      ) {
        this.showImg = true;
      } else {
        this.$alert("当前文件类型暂不支持预览", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overviewFile {
  height: 100%;
  width: 100%;
  overflow: hidden;

  .header {
    height: 50px;
    text-align: left;
  }

  .main {
    height: calc(100% - 100px);
    overflow: auto;

    .content {
      height: 100%;

      iframe {
        height: 100%;
      }
    }
  }
}
</style>
